export const DEFAULT_VALUES = {
  email: '',
  password: ''
}

export const ERROR_MESSAGES = {
  403: 'Sua conta está bloqueada temporariamente',
  DEFAULT: 'E-mail ou senha inválidos'
}
